import { environment } from '@environments/environment';
import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, input } from '@angular/core';
import { AnimationPlayerComponent } from '../animation-player.component';

@Component({
  selector: 'cgw-success-animation',
  standalone: true,
  templateUrl: './../animation-player.component.html',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SuccessAnimationComponent extends AnimationPlayerComponent {
  //#region I/O
  public override readonly src = input<string>(
    `${environment.apiStatic}animations/success_animation.lottie`,
  );
  //#endregion
}
